// order matters here, so we use have to use "require" instead of "import"
require('semantic-ui-less/semantic.less')
require('react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css')
require('./inter/inter.css')
require('./app.css')